import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { startLoading, doneLoading } from '../../../utils/loading'
import ClosureApproveRequestSearchForm from './ClosureApproveRequestSearchForm'
import ClosureApproveRequestTable from './ClosureApproveRequestTable'
import { cloneDeep } from 'lodash'
import { searchAssetClosureApprove } from '../../../redux/actions/accountingAssetClosure'
import { sessionGetItemStr, sessionSetItemStr } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import pathname from '../../../constants/pathname'

export default function ClosureApproveRequestWidget(props) {
  const { step } = props
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isViewMode, setIsViewMode] = useState(props.isViewMode)
  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)
  const [searchRequest, setSearchRequest] = useState({})

  const handleSearch = async (pagenumber, pagesize, request) => {
    setIsLoading(true)
    startLoading()
    try {
      console.log(pagenumber, pagesize, request)
      setPage(pagenumber)
      setDisplayLength(pagesize)
      setSearchRequest(request)

      const response = await searchAssetClosureApprove(request, step, pagenumber, pagesize)
      // console.log('getLegalManagement ', _schema)
      var _schema = cloneDeep(formSchema)

      _schema.result = response.model

      setFormSchema(_schema)
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  const onReload = (pagenumber, pagesize) => {
    handleSearch(pagenumber, pagesize, searchRequest)
  }

  const onSearch = (request) => {
    handleSearch(1, displayLength, request)
  }

  const handleSelect = (data) => {
    // console.log('handleSelect ', data)
    sessionSetItemStr('projectCode', data.projectCode || '')
    sessionSetItemStr('assetClosureStep', step)
    sessionSetItemStr('assetClosureId', data.id || '')

    history.push({
      pathname: `${pathname.durableArticles.ManageDurableArticles}`,
    })
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        {formSchema?.searchForm && (
          <div style={{ marginTop: 0 }}>
            <ClosureApproveRequestSearchForm
              schema={formSchema.searchForm}
              onSearch={onSearch}
              loading={isLoading}
            />
          </div>
        )}

        <ClosureApproveRequestTable
          schema={formSchema?.result}
          loading={isLoading}
          onReload={onReload}
          page={page}
          displayLength={displayLength}
          isViewMode={isViewMode}
          onSelect={handleSelect}
        />
      </Panel>
    </>
  )
}
